import React, {useEffect, useContext, useCallback} from 'react';
import CommandsContext from '../../../context/commandsContext';
import MenuContext from '../../../context/menuContext';
import useKeyPress from '../../../hooks/useKeyPress';
import Home from '../../home';
import BodyContentView from '../../views/bodyContentView';

function SetupComplete({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {setDisableMenu} = useContext(MenuContext);
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    setDisableMenu(false);
    onExit();
  }, []);

  const onRight = useCallback(() => {
    setDisableMenu(false);
    onExit();
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight});
  }, [onLeft, onRight]);

  return (
    <BodyContentView
      title="Guided Setup Complete"
      left="No"
      right="Yes"
      caption="Guided setup is complete. Do you want this device to prompt for guided setup at each start-up?"
    />
  );
}

export default SetupComplete;
